import brands from "../services/brands";
import notification from "../services/notification";
import router from "../router";

const mutations = {
    reset(state) {
        state.created = false;
        state.deleted = false;
        state.updated = false;
        state.errors = {};
        state.loading = false;
    },
    brands(state, brands) {
        state.brands = brands;
        state.loading = false;
    },
    visibleBrands(state, visibleBrands) {
        state.visibleBrands = visibleBrands;
        state.loading = false;
    },
    loading(state, value) {
        state.loading = value;
    },
    errors(state, errors) {
        state.errors = errors;
    },
    created(state) {
        state.created = true;
    },
    updated(state) {
        state.updated = true;
    },
    deleted(state) {
        state.deleted = true;
    },
    view(state, data) {
        state.view = data;
        state.loading = false;
    },
    setCreatedBrand(state, value) {
        state.createdBrand = value;
    }
};

const getters = {
    brands: state => state.brands,
    loading: state => state.loading,
    visibleBrands: state => state.visibleBrands,
    errors: state => state.errors
};

const actions = {
    async getBrands({ commit }) {
        commit("loading", true);
        try {
            let response = await brands.getBrands();
            commit("brands", response);
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },

    async getVisibleBrands({ commit }) {
        commit("loading", true);
        try {
            let response = await brands.getVisibleBrands();
            commit("visibleBrands", response);
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },

    async create({ commit }, payload) {
        commit("loading", true);
        commit("setCreatedBrand", null);

        try {
            const { message, brand } = await brands.create(payload);
            notification.success(message);
            commit("created");
            commit("setCreatedBrand", brand);
        } catch (errors) {
            commit("errors", errors);
        }  finally {
            commit("loading", false);
        }
    },

    async update({ commit }, payload) {
        commit("loading", true);
        try {
            let response = await brands.update(payload.uuid, payload);
            
            if (router.currentRoute.name !== "onboarding")
              notification.success(response.message);
            
            commit("updated");
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },

    async view({ commit }, uuid) {
        commit("loading", true);
        try {
            let response = await brands.view(uuid);
            commit("view", response);
        } catch (errors) {
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    },

    async delete({ commit }, uuid) {
        commit("loading", true);
        try {
            let response = await brands.delete(uuid);
            notification.success(response.message);
            commit("deleted", response);
        } catch (errors) {
            notification.error(errors.message);
            commit("errors", errors);
        } finally {
            commit("loading", false);
        }
    }
};

export default {
    namespaced: true,
    state: {
        brands: [],
        visibleBrands: [],
        loading: false,
        errors: {},
        view: {},
        created: false,
        updated: false,
        deleted: false,
        createdBrand: null
    },
    actions,
    mutations,
    getters
};
